import { BfiApi, IApiResponse } from './bfiApi';

export interface ITempFile {
    tempName: string;
    cleanedName: string;
}

export interface IDownloadRequest {
    token: string;
}

export interface IUploadTempFileResponse extends Omit<IApiResponse, 'result'> {
    result: [ITempFile];
}

export class FileApi extends BfiApi {
    downloadUrl(request: IDownloadRequest): Promise<IApiResponse> {
        return super.post('/files/downloadurl', request);
    }

    uploadTempFiles(files: any): Promise<IUploadTempFileResponse> {
        const formData = new FormData();
        files.forEach((f) => {
            formData.append('files', f);
        });
        return super.post('/files/tempfiles', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }
}
